import { render, staticRenderFns } from "./DashboardEquipamiento.vue?vue&type=template&id=51ccca96&scoped=true"
import script from "./DashboardEquipamiento.vue?vue&type=script&lang=js"
export * from "./DashboardEquipamiento.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipamiento.vue?vue&type=style&index=0&id=51ccca96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccca96",
  null
  
)

export default component.exports